import React from 'react';
import './Features.css';

const features = [
  { icon: '👨‍🏫', title: 'Expert Faculty', desc: 'Highly qualified and experienced teachers with subject-matter expertise and a passion for teaching.' },
  { icon: '👥', title: 'Small Batches', desc: 'Maximum 15 students per batch ensuring every student gets focused, personalized attention.' },
  { icon: '📝', title: 'Regular Tests', desc: 'Weekly tests and monthly assessments to track progress and identify areas for improvement.' },
  { icon: '💡', title: 'Doubt Sessions', desc: 'Dedicated doubt-clearing sessions every week so no question goes unanswered.' },
  { icon: '📖', title: 'Study Material', desc: 'Comprehensive notes, worksheets, and practice papers provided at no extra cost.' },
  { icon: '⏰', title: 'Flexible Timings', desc: 'Morning and evening batches available to accommodate school schedules and extracurricular activities.' },
];

export default function Features() {
  return (
    <div className="features">
      <div className="features__container">
        <h2 className="section-title">Why Choose Triumph Classes?</h2>
        <div className="section-divider"></div>
        <p className="section-subtitle">
          We combine the best teaching methods with the right environment to help every student reach their full potential
        </p>
        <div className="features__grid">
          {features.map((f) => (
            <div key={f.title} className="feature-card">
              <div className="feature-card__icon">{f.icon}</div>
              <h3 className="feature-card__title">{f.title}</h3>
              <p className="feature-card__desc">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
